import { useState } from "react";
import { motion } from "framer-motion";
import subscribeToBrevo from "../../services/brevo";
import styles from "./EmailSignup.module.css";

const EmailSignup = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    setIsSubmitting(true);
    setStatus("Joining...");

    try {
      await subscribeToBrevo(email);
      setStatus("You're on the list!");
      setEmail("");
    } catch (error) {
      setStatus("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }

    setTimeout(() => {
      setStatus("");
    }, 4000);
  };

  const sectionFade = {
    hidden: {
      opacity: 0,
      y: 28,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  return (
    <motion.section
      className={styles.subscribeSection}
      variants={sectionFade}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.35 }}
    >
      <div className={styles.inner}>
        <div className={styles.heading}>
          <span className={styles.eyebrow}>Stay in the loop</span>
          <h2 className={styles.title}>
            Join Marléna's
            <span>mailing list.</span>
          </h2>
        </div>

        <div className={styles.formWrapper}>
          <p className={styles.copy}>
            Booking announcements, updates, and new work delivered occasionally.
          </p>

          <form
            onSubmit={handleSubmit}
            className={styles.form}
          >
            <input
              type="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className={styles.input}
            />

            <button
              type="submit"
              className={styles.button}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Joining..." : "Subscribe"}
            </button>
          </form>

          {status && (
            <motion.p
              className={styles.status}
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
            >
              {status}
            </motion.p>
          )}
        </div>
      </div>
    </motion.section>
  );
};

export default EmailSignup;